import * as actionTypes from '../actionTypes';
export const getAreaNames = (payload) => {
    return {
        type: actionTypes.GetAreaNames,
        payload
    };
};

// Add area name
export const addAreaName = (data) => ({
  type: actionTypes.AddAreaName,
  payload: data
});

// Update area name
export const updateAreaName = (payload) => {
    const action = {
        type: actionTypes.UpdateAreaName,
        payload
    };
    return action;
};